// extracted by css-extract-rspack-plugin
export default {"accordionListRoot":"AccordionList-module__accordionListRoot___I4OMZ","hasSearch":"AccordionList-module__hasSearch___SgSQw"};